<template>
  <div>
    <a @click.prevent="focusCurrentSidebarItem()" href="#current-sidebar-item" id="tuka-skip-to-active-sidebar-item">{{$t('tuka.navigation.skip_to_active_sidebar_item')}}</a>
    
    <div 
      id="tuka-content-container"
      tabindex="-1"
    >

      <search-results 
        v-if="searchResults.errorMessage.length || searchResults.data.length" 
      />

      <div
        v-if="!searchResults.data.length && !searchResults.errorMessage.length"      
        class="single-content"
        v-for="item in mainContent"
        :id="'tuka-content-' + getIdFromLocationData(item.locationData)" 
        :class="contentItemCss(getFilters, themeWords, item.themeWords, item.locationData)"
      >
        <div class="attachments content-item-attachments top-attachments">
          <div class="single-attachment" v-for="attachment in item.attachments">
            <a 
              :href="urlWithoutDownloadParameter(attachment.url)"
              target="_blank"
              class="attachment pdf"
              :data-extension="attachment.type ? attachment.type : ''"
              :data-size="attachment.size ? attachment.size : ''"
            >
              {{attachment.title}}
              <span class="sr-only">Tiedosto avautuu uudessa välilehdessä</span>
              <span class="file-ext">{{attachment.type ? attachment.type : ''}}</span><span class="file-size"> {{attachment.size ? attachment.size : ''}}</span>
            </a>
          </div>
        </div>

        <div class="themeWords">
            <span 
              v-for="(active, name) in item.themeWords"
              :class="active ? 'active' : ''"
            >
            {{name}}
            </span>
        </div>

        <intersect @change="intersectChange" @enter="intersectEnter" @leave="intersectLeave" :root="rootElement()" :threshold="[0,0.01]">
          <div class="intersect-helper-element" :data-content-id="item.contentId"></div>
        </intersect>

        <div
          class="content"
          :location-data-formatted="formattedLocationData(item.locationData)"
          v-html="item.content"
        >
        </div>

      </div>

      <div 
        v-if="!searchResults.data.length && !searchResults.errorMessage.length"
        class="no-active-themewords-in-content-view"
      >
        <div
          v-if="getFilters.themeWords == true && 
          mainContentHasItemsWithActiveThemeWords != null && 
          !mainContentHasItemsWithActiveThemeWords &&
          tukaReady == true"
          class="no-active-themewords-message"
        >
          <h2 class="no-active-themewords-message-header">
            {{$t('tuka.messages.no_active_themewords.header')}}
          </h2>
          <p class="no-active-themewords-message-text">
            {{$t('tuka.messages.no_active_themewords.content')}}
          </p>
        </div>
      </div>

    </div>
    <vue-accessible-modal />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getIdFromLocationData, formattedLocationData, getURLFromItemName } from "../store/helpers";

import SearchInfo from "./SearchInfo.vue";
import SearchResults from "./SearchResults.vue";
import ImageModal from "@/components/ImageModal";
import { i18n } from "../translations/i18n";

import Intersect from 'vue-intersect'

export default {
name: "MainContent",
components: {
  SearchInfo,
  SearchResults,
  Intersect,
  ImageModal
},
data() {
  return {
    image: {
      src: "",
      title: "",
      alt: ""
    }
  };
},
watch: {
  'scrollingReserved': {
    handler(newValue, oldValue) {

      // After main content scrolling ends, ensure active page is marked in the sidebar
      if (!newValue) {
        const targetElem = document.querySelector('.tukave-main-content .single-content .intersect-helper-element');
        if (!targetElem) return;
        if (!targetElem.hasAttribute('data-content-id')) return;

        const pageContentId = targetElem.dataset.contentId;
        if (pageContentId) {
          const sameId = Number(pageContentId) === Number(this.visibleContentId)
          if (!jQuery("#side-nav-list .current-visible-item").length || !sameId) {
            this.setVisibleContentId(pageContentId)
          }
        }
      }
    }
  }
},
computed: {
  ...mapGetters(["dataContent", "mainContent", "themeWords", "getFilters", "getSettings", "searchResults", "mainContentHasItemsWithActiveThemeWords", "tukaReady", "currentItemLocationData", "scrollingReserved", "visibleContentId"]),
},
mounted() {
  this.handleImageClicks()


},
updated() {
  const vueThis = this; // Make current vue instance accessible to js/jquery functions

  // Add different index data to main content elements
  jQuery('.tukave-main-content .single-content .content').each(function() {

    // Insert navigation index data into headers
    jQuery(this).find("[data-header-navigation-index]").each(function() {

      // Check if data-value is letter or not
      const indexValue = jQuery(this).data('header-navigation-index');
      let isLetter = false;

      if (indexValue.length > 0) {
         isLetter =  /^[a-zA-Z()]+$/.test(indexValue);
      }

      // Only add index data if it hasn't been already inserted and is not letter
      if (!jQuery(this).find('.header-navigation-index').length && !isLetter) {
        let insertText = '<span class="header-navigation-index">' + jQuery(this).attr('data-header-navigation-index')  + '</span>';
        jQuery(this).prepend(insertText);
      }
    });

    // Insert table index data into caption
    jQuery(this).find("table [data-table-caption-index]").each(function() {

      // Only add index data if it hasn't been already inserted
      if (!jQuery(this).find('.table-caption-index').length) {
        let captionName = i18n.messages[i18n.locale].tuka.content.table_caption;
        let insertText = '<span class="table-caption-index">' + captionName + " " + jQuery(this).attr('data-table-caption-index') + ". " + '</span>';
        jQuery(this).prepend(insertText);
      }
    });

    // Insert figure index data into caption
    jQuery(this).find("figure [data-figure-caption-index]").each(function() {

      // Only add index data if it hasn't been already inserted
      if (!jQuery(this).find('.figure-caption-index').length) {
        let captionName = i18n.messages[i18n.locale].tuka.content.figure_caption;
        let insertText = '<span class="figure-caption-index">' + captionName + " " + jQuery(this).attr('data-figure-caption-index') + ". " + '</span>';
        jQuery(this).prepend(insertText);
      }
    });

    function moveNextTietolaatikkoItemsRecursively(origItem, index, tietolaatikkoBox) {

      let nextItem = jQuery(origItem).next(); // Save next item of original item
      jQuery(origItem).appendTo(tietolaatikkoBox); // Move original item into tietolaatikko-box

      // Check if next item is .tietolaatikko and not a new tietolaatikko header
      const hasTietolaatikkoClass = jQuery(nextItem).hasClass("tietolaatikko");
      const hasTukaHeaderClass = jQuery(nextItem).hasClass("tuka-header");
      if ( hasTietolaatikkoClass && !hasTukaHeaderClass ) {
        moveNextTietolaatikkoItemsRecursively(nextItem, index, tietolaatikkoBox);
      }
    }

    // Create unique tietolaatikko-boxes and insert following siblings with .tietolaatikko into them
    jQuery(this).find(".tietolaatikko").each(function(index) {

      // Prevent items from moving if they're already in box
      if (!jQuery(this).parent().hasClass("tietolaatikko-box")) {

        let tietolaatikkoBox = document.createElement("div");
        tietolaatikkoBox.className = "tietolaatikko-box tietolaatikko-box-" + index;
        tietolaatikkoBox.setAttribute('aria-label', i18n.t('tuka.content.info_box'));
        tietolaatikkoBox.setAttribute('role', 'region');
        jQuery(tietolaatikkoBox).insertBefore(this);

        moveNextTietolaatikkoItemsRecursively(this, index, tietolaatikkoBox);
      }


    });

    function anchorEvent(event) {
      event.preventDefault();
      let anchorTargetId = jQuery(this).attr("href")
      vueThis.handleAnchorClick(anchorTargetId);
    }

    // Overwrite anchor functionality, allow vue-router compatible url generation and transition
    jQuery(this).find(".footnote-ref").each(function() {
      jQuery(this).off("click") // Prevents duplicate click events by removing existing events
      jQuery(this).on("click.anchorEvent", anchorEvent);
    });
    jQuery(this).find(".footnotes > p").each(function() {

      jQuery(this).attr("tabindex", "-1"); // Allow element to be focused

      jQuery(this).find("a[href*='#footnote-ref-']").each(function() {
        jQuery(this).off("click") // Prevents duplicate click events by removing existing events
        jQuery(this).on("click.anchorEvent", anchorEvent);
      })
    });

    /*
    let locationData = jQuery(this).attr('location-data-formatted');
    let h3Index = 1;

    // Dont add heading number to heading 0
    if (locationData && locationData !== "0") {
      const formattedLocationDataHeading = "<span class='location-data-formatted-heading'>" + locationData + "</span>";

      let firstChildElement = jQuery(this).find('.indesign-content-container >:first-child');
      if (firstChildElement && !firstChildElement.find('.location-data-formatted-heading').length &&
          !firstChildElement.hasClass('liite') &&
          !firstChildElement.hasClass('esipuhe-lahde')) { // Prevent adding of duplicates
            firstChildElement.prepend(formattedLocationDataHeading);
      }


      // Add level 3 numbering to H3 headings
      const h3 = jQuery(this).find('h3');

      if (!h3.hasClass('liite') && !h3.hasClass('lahde')) {
        h3.each(function () {
          let subIndexPath = `${locationData}.${h3Index}`;
          const formattedLocationH3Data = `<span class='location-data-formatted-heading'>${subIndexPath}</span>`;
          jQuery(this).prepend(formattedLocationH3Data);
          h3Index += 1;
        });
      }

    }
    */


  })
},
methods: {
  ...mapActions(["collabdata", "updateCurrentItemLocationData", "setThemeWords", "setVisibleContentId", "setScrollingReserved"]),
  formattedLocationData: formattedLocationData,
  getIdFromLocationData: getIdFromLocationData,
  getURLFromItemName: getURLFromItemName,
  intersectChange(intersectionObserverEntry) {
    // console.log("INTERSECTION CHANGED")
    // console.log(intersectionObserverEntry)
  },
  intersectEnter(intersectionObserverEntry) {
    // console.log("INTERSECTION ENTERED")
    let contentId = intersectionObserverEntry[0].target.dataset.contentId;
    if (contentId) {

      // Prevent visible content id from updating if another scroll is ongoing
      if (!this.scrollingReserved) {
        this.setVisibleContentId(contentId)
      }
    }
  },
  intersectLeave(intersectionObserverEntry) {
    // console.log("INTERSECTION LEFT")
  },
  rootElement() {
    return document.getElementsByClassName('.tukave-main-content')[0];
  },
  locationId(locationData) {
    if (!locationData) return "";
    return getIdFromLocationData(locationData);
  },
  hasActiveThemeWords(filters, themeWords, currentThemeWords) {
    if (!filters.themeWords) return true; // themeWords filters not activated

    for (let name in currentThemeWords) {
      if (currentThemeWords[name]) return true;
    }
    return false;
  },
  focusCurrentSidebarItem() {
    this.$nextTick(function() {

      let targetItem = jQuery("#side-nav-list").find(".current.active-item");

      if (targetItem.length) {
        targetItem.find("a.name")[0].focus({
          preventScroll: false
        });
      } else {

        // If target is not found, return to first item in sidebar
        jQuery("#side-nav-list").find("a.name").first()[0].focus({
          preventScroll: false
        });
      }
    });
  },
  contentItemCss(getFilters, themeWords, currentThemeWords, locationData) {

    let cssString = ""
    if (this.getFilters.themeWords == false) {
      cssString += "active "; // themeword filter not active
    } else {
      if (this.hasActiveThemeWords(getFilters, themeWords, currentThemeWords)) {
        cssString += "active "; // item has active themeword
      }
    }

    if (!cssString) {
        cssString = "deactive ";

        if (this.getSettings.hideThemeWordsWithNomatches) {
          cssString += "hidden ";
        }
    }

    if (this.getSettings.showContentInFullHeight) {
      cssString += "height-auto ";
    }

    if (locationData && locationData.length) {
      cssString += "location-data-levels-" + locationData.length;
    } else {
      cssString += "location-data-levels-none";
    }


    return cssString;
  },
  urlWithoutDownloadParameter(attachmentUrl) {
    // TODO: remove frontend url handling, provide correct url from backend
    if (attachmentUrl && attachmentUrl.length) {
      return attachmentUrl.replace('&download=true', '');
    } else {
      return attachmentUrl;
    }
  },
  handleAnchorClick(anchorTargetId) {

    /* 1. Get target location info and set it into params */
    let tempLocation = [];
    if (this.currentItemLocationData) { // Normal item, use locationData
      for (let i = 1; i < this.currentItemLocationData.length; i++) {
        tempLocation.push(this.currentItemLocationData[i]);
      }
    }

    // Prevent root item ["0"] to be inserted to url
    if (tempLocation && tempLocation[0] == "0") {
      tempLocation = [];
    }

    let pushParams = {
      componentPage: this.$router.currentRoute.params.componentPage,
      componentId: tempLocation,
    }

    /* 2. Get possibly active filters and set them into query */
    let activeThemewords = Object.keys(this.themeWords).filter(key => this.themeWords[key] === true);
    let pushQuery = {
      themeword: activeThemewords
    }


    /* 3. Dispatch router request with parameters, e.g. /katsaus/2/0?themeword=ilmastonmuutos#22 */
    let allowFocusScroll = false;
    this.$router.push({
      name: 'componentpage',
      params: pushParams,
      query: pushQuery,
      hash: anchorTargetId
    }).catch(err => {
      console.log("Reroute to same location");
      allowFocusScroll = true;
    });

    this.setScrollingReserved(true);

    this.$nextTick(() => {
      setTimeout(() => {
        // Focus anchor target item, with focus if link is clicked second time (url stays same)
        if (allowFocusScroll) {
          document.getElementById(anchorTargetId.replace("#","")).focus();
        } else {
          document.getElementById(anchorTargetId.replace("#","")).focus({
            preventScroll: true
          });
        }
      }, 100);
    });

    setTimeout(() => {
      this.setScrollingReserved(false);
    }, 2000)
  },
  openImageOnModal(event) {
    if (event.target.nodeName === 'IMG') {
      const image = event.target
      let figCaption = ""
      // Check if image has figcaption text
      if (image.previousElementSibling !== null) {
        if (image.previousElementSibling.nodeName === 'FIGCAPTION') {
          figCaption =  image.previousElementSibling.innerHTML
        }
      }

      // Open modal
      this.$modal.show(ImageModal, {
        props: { image: image, figcaption: figCaption, isVisible: true },
        label: image.alt,
        attributes: {
          id: 'modal'
        },
        transition: 'fade',
      })

    }
  },
  handleImageClicks() {
    const mainContentArea = document.querySelector('.tukave-main-content')
    if (mainContentArea) {

      setTimeout( () => {
        const images = [...mainContentArea.querySelectorAll('img')];

        if (images.length > 0) {
          images.forEach(image => {
            // Make images reachable by keyboard
            image.setAttribute('tabindex','0');
            image.classList.add('clickable');
          });
        }
      }, 1000)

      mainContentArea.addEventListener('click', (event) => { this.openImageOnModal(event) }, false)
      mainContentArea.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {
          this.openImageOnModal(event)
        }
      }, false)
    }

  },
  setFormattedLocation(location) {
    if (location.match(/[a-z]/i)) {
      return getURLFromItemName(location);
    } else {
      return formattedLocationData(location);
    }

  }
},
};
</script>

<style lang="scss">

</style>
